import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicPartyDto extends EpimsBaseEntityDto {
  PartyChiefName: string;
  ContractorId: string;
  SubscriptionUserId: string;
  Version: number;
}
